export const ImageIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M2.5 13.3333V13.3333C2.5 13.7203 2.5 13.9138 2.51605 14.0767C2.67192 15.6593 3.92402 16.9114 5.50661 17.0673C5.66958 17.0833 5.86305 17.0833 6.25 17.0833H13.75C14.1369 17.0833 14.3304 17.0833 14.4934 17.0673C16.076 16.9114 17.3281 15.6593 17.4839 14.0767C17.5 13.9138 17.5 13.7203 17.5 13.3333V13.3333M2.5 13.3333V8.91667C2.5 6.41685 2.5 5.16694 3.13661 4.29072C3.34221 4.00774 3.59107 3.75888 3.87405 3.55328C4.75027 2.91667 6.00018 2.91667 8.5 2.91667H11.5C13.9998 2.91667 15.2497 2.91667 16.126 3.55328C16.4089 3.75888 16.6578 4.00774 16.8634 4.29072C17.5 5.16694 17.5 6.41685 17.5 8.91667V13.3333M2.5 13.3333L4.40609 10.6648C5.22081 9.52421 5.62817 8.95391 6.14761 8.78367C6.48482 8.67315 6.84851 8.67315 7.18573 8.78367C7.70517 8.95391 8.11253 9.52421 8.92725 10.6648L9.34996 11.2566C9.66026 11.691 9.81542 11.9083 9.98176 12.0463C10.5202 12.493 11.2804 12.556 11.8849 12.2038C12.0717 12.095 12.2604 11.9062 12.6379 11.5287V11.5287C12.9635 11.2032 13.1263 11.0404 13.2927 10.9379C13.8286 10.6078 14.5047 10.6078 15.0407 10.9379C15.207 11.0404 15.3698 11.2032 15.6954 11.5287L17.5 13.3333M15 6.875C15 7.68042 14.3471 8.33334 13.5417 8.33334C12.7363 8.33334 12.0833 7.68042 12.0833 6.875C12.0833 6.06959 12.7363 5.41667 13.5417 5.41667C14.3471 5.41667 15 6.06959 15 6.875Z"
        stroke="#667085"
        stroke-width="1.67"
        stroke-linejoin="round"
      />
    </svg>
  );
};

ImageIcon.displayName = "ImageIcon";
